import React, { useContext, useEffect } from "react";
import { MapContext } from "../../contexts/map";

import mapboxgl from "mapbox-gl";

export type ControlPosition =
  | "top-left"
  | "top-right"
  | "bottom-left"
  | "bottom-right";

interface MapControlProps {
  control: mapboxgl.Control | mapboxgl.IControl;
  position: ControlPosition;
}

const MapControl: React.FC<MapControlProps> = ({ control, position }) => {
  const { map, setMap } = useContext(MapContext);

  useEffect(() => {
    if (map) {
      map.addControl(control, position);
      setMap(map);
    }

    return () => {
      if (map) {
        map.removeControl(control);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <></>;
};

export default MapControl;
